import axios from 'axios'

import { useCookies } from '@vueuse/integrations/useCookies'
import _ from 'underscore';

import Api from '@/Libs/Api/Index'
import Axios from '@/Libs/Axios'
import Loading from '@/Libs/Loading'
import Flash from '@/Libs/Flash'
import OrderBy from '@/Libs/OrderBy'
import Alert from '@/Libs/Alert'
import AccessControl from '@/Libs/AccessControl'
import Sidebar from '@/Libs/Sidebar'

import DateFormatter from '@/Libs/Core/DateFormatter'

import Pagination from '@/Libs/Components/Pagination'
import Timepicker from '@/Libs/Components/Timepicker'
import Datepicker from '@/Libs/Components/Datepicker'
import Sortable from '@/Libs/Components/Sortable'
import Skeleton from '@/Libs/Components/Skeleton'
import LoadingWrapper from '@/Libs/Components/Loading'
import DynamicSelect from '@/Libs/Components/DynamicSelect'
import BtnSidebar from '@/Libs/Components/BtnSidebar'
import DynamicSidebar from '@/Libs/Components/DynamicSidebar'

var Cafeman = {
    install(app, options) {
        const { i18n } = options;

        var router = app.config.globalProperties.$router
        var store = app.config.globalProperties.$store
        var cookies = useCookies()
        var instance = new Axios(axios, cookies, router, i18n)

        app.config.globalProperties.$cookies = cookies
        app.config.globalProperties.$api = new Api(instance, cookies)
        app.config.globalProperties.$loading = new Loading(store)
        app.config.globalProperties.$flash = new Flash(i18n)
        app.config.globalProperties.$orderBy = new OrderBy()
        app.config.globalProperties.$alert = new Alert(i18n)
        app.config.globalProperties.$dateFormat = new DateFormatter()
        app.config.globalProperties.$ac = new AccessControl(store, app.config.globalProperties.$api, router)
        app.config.globalProperties.$_ = _;
        app.config.globalProperties.$sidebar = new Sidebar(store);

        app.component('pagination', Pagination);
        app.component('timepicker', Timepicker);
        app.component('datepicker', Datepicker);
        app.component('sortable', Sortable);
        app.component('skeleton', Skeleton);
        app.component('loading', LoadingWrapper);
        app.component('dynamic-select', DynamicSelect);
        app.component('dynamic-sidebar', DynamicSidebar);
        app.component('btn-sidebar', BtnSidebar);
    }
};

export default Cafeman;